var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBenchWhite = function SvgBenchWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.781 15.139-2.11 5.111H2.157l2.11-5.111m4.662-2.78 2.369-5.74H7.78l-2.368 5.74m14.058 2.78 2.373 5.111h-3.516l-2.11-5.111m1.962-2.78-2.664-5.74h-2.813l2.369 5.74m-12.916 2.87h19.688c.776 0 1.406-.643 1.406-1.435 0-.793-.63-1.435-1.406-1.435H2.156C1.38 12.359.75 13 .75 13.794c0 .792.63 1.434 1.406 1.434Zm4.219-8.61h11.25c.777 0 1.406-.642 1.406-1.434 0-.793-.63-1.435-1.406-1.435H6.375c-.777 0-1.406.642-1.406 1.435 0 .792.63 1.435 1.406 1.435Z"
  })));
};
export default SvgBenchWhite;